import isNil from 'lodash-es/isNil';

const DEFAULT_PREFIXES = ['PRO', 'GCP', 'CFA', 'REC', 'EXTEND', 'EXTENDPP'];

const PREFIXES_SEPARATOR = ',';

export function getAllowedPrefixes(): string[] {
    const envPrefixes =
        typeof process !== 'undefined' ? process.env.ALLOWED_SKU_PREFIXES : undefined;
    if (envPrefixes && envPrefixes.trim() !== '') {
        return envPrefixes
            .split(PREFIXES_SEPARATOR)
            .map((prefix) => prefix.trim())
            .filter(Boolean);
    }

    return DEFAULT_PREFIXES;
}

export function isValidSKU(sku: string | null | undefined): boolean {
    if (isNil(sku) || sku.trim() === '') {
        return false;
    }

    const allowedPrefixes = getAllowedPrefixes();

    const patternDigitsOnly = /^\d+$/;
    const prefixPattern = allowedPrefixes.join('|');
    const patternAllowedPrefixes = new RegExp(`^(${prefixPattern})-\\d+$`);

    return patternDigitsOnly.test(sku) || patternAllowedPrefixes.test(sku);
}
